import { AxiosService } from './';
import { Alert } from './';

const getVoucherList = async (
  _perPage,
  _page,
  commonSearch,
  sortBy,
  status,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/vouchers/list',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: commonSearch,
        sortOption: sortBy,
        status: status,
      },
    };
    const response = await AxiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const getCategory = async () => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/project_types',
      isAuthorized: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const createVoucher = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/vouchers/',
      isAuthorized: true,
      isMultipart: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const checkVoucher = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/vouchers/check_exists',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const getVoucherDetails = async (_projectId) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/vouchers/' + _projectId,
      isAuthorized: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const updateVoucher = async (_formData, _projectId) => {
  if (!_formData) {
    Alert.error("Voucher can't be updated");
    return;
  }
  try {
    let axiosData = {
      method: 'put',
      url: `admin/vouchers/${_projectId}`,
      isAuthorized: true,
      isMultipart: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const getVoucherUtilizationList = async (_perPage, _page, _voucherId) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/vouchers/utilization_list',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        voucher_id: _voucherId,
      },
    };
    const response = await AxiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const updateVoucherStatus = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/vouchers/update_status',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

export {
  getVoucherList,
  getVoucherDetails,
  updateVoucher,
  checkVoucher,
  getCategory,
  createVoucher,
  updateVoucherStatus,
  getVoucherUtilizationList,
};
